import { render, staticRenderFns } from "./ModelTypeSelect.vue?vue&type=template&id=5b65c936&scoped=true"
import script from "./ModelTypeSelect.vue?vue&type=script&lang=js"
export * from "./ModelTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./ModelTypeSelect.vue?vue&type=style&index=0&id=5b65c936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65c936",
  null
  
)

export default component.exports